/* stylelint-disable csstree/validator */
import { Keyframes, keyframes } from 'styled-components'

export const shapeScaleIn = keyframes`
  from {
    transform: scale(0,0);
  }

  to {
    transform: scale(1,1);
  }
`
export const shapeScaleOut = keyframes`
  from {
    transform: scale(1,1);
  }

  to {
    transform: scale(0,0);
  }
`

export const scaleIn = (rotationStartAngle: string): Keyframes =>
  keyframes`
  from {
    transform: scale(0,0);
  }
  to {
    transform: scale(1,1) ${(() => `rotate(${rotationStartAngle})`)()};
    animation-fill-mode: forwards;
  }
`

export const spin = (
  rotationStartAngle: string,
  rotationEndAngle: string,
): Keyframes =>
  keyframes`
    0% {
      transform: ${(() => `rotate(${rotationStartAngle})`)()};
    }
    100% {
      transform: ${(() => `rotate(${rotationEndAngle})`)()};
    }
`

export const snap = (isClockwise: boolean): Keyframes =>
  keyframes`
    from {
      transform: ${(() => `rotate(${isClockwise ? '90deg' : '-90deg'})`)()};
    }
    to {
      transform: rotate(0deg);
    }
`
